module.exports = __webpack_public_path__ + "img/find-document.40cafae6.svg";